module.exports = __webpack_public_path__ + "static/img/menageService2.b339ce73.png";